import { defineStore } from "pinia";
import i18n from "../../locales/index.js";

export const useGlobalStore = defineStore("global", {
  state: () => {
    const { locale, t } = i18n.global;
    return {
      alert: {
        show: false,
        message: "",
        type: "",
        status: "success",
      },
      hideLoading: false,
      isLoading: false,
      APIisLoading: false,
      saveLink: "",
      lightHeaderText: "Home",
      showSidebar: false,
      changeIconColor: false,
      langList: [
        { name: t("english"), value: "en-US" },
        { name: t("traditional-chinese"), value: "zh-TW" },
        { name: t("japanese"), value: "ja-JP" },
      ],
      showNotification: false,
      aichatVoice: "Aoede",
    };
  },
  actions: {},
});
